import React, { useState, createContext, useEffect } from "react";
import firebase from "firebase/app";
import { auth } from "../services/firebase";
import { updateUserToken } from "../helpers/authHelpers";
import { updateMyPhoto } from "../api/user";
import { E2E_AUTH_TOKEN, isE2EAuthEnabled } from "../config/e2e";

interface AuthContextProps {
  authAttempted: boolean;
  user: firebase.User | null;
}

const defaultContextValue = {
  authAttempted: false,
  user: null,
};

export const AuthContext = createContext<AuthContextProps>(defaultContextValue);

interface UserProviderProps {
  children: React.ReactChild | React.ReactChildren;
}

const e2eUser = {
  uid: E2E_AUTH_TOKEN,
  displayName: "Playwright Super Admin",
  email: "playwright@example.invalid",
  photoURL: null,
  getIdToken: async () => E2E_AUTH_TOKEN,
} as unknown as firebase.User;

function FirebaseUserProvider(props: UserProviderProps) {
  const { children } = props;
  const [user, setUser] = useState<firebase.User | null>(null);
  const [authAttempted, setAuthAttempted] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (userAuth) => {
      console.log("AuthProvider onAuthStateChanged", { userAuth });
      setUser(userAuth);
      setAuthAttempted(true);
      await updateUserToken();
      if (userAuth?.photoURL && !sessionStorage.getItem("photoSynced")) {
        sessionStorage.setItem("photoSynced", "true");
        updateMyPhoto(userAuth.photoURL).catch(() => {});
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ authAttempted, user }}>
      {children}
    </AuthContext.Provider>
  );
}

function UserProvider(props: UserProviderProps) {
  if (isE2EAuthEnabled()) {
    return (
      <AuthContext.Provider value={{ authAttempted: true, user: e2eUser }}>
        {props.children}
      </AuthContext.Provider>
    );
  }

  return <FirebaseUserProvider {...props} />;
}

export default UserProvider;
